import { Outlet } from "react-router-dom";
import Header from "../Header";
import { Toaster } from "sonner";
import { autoLogoff } from "hooks/useWebSocket";
import { Box, Container, Flex } from "@mantine/core";
import Footer from "./Footer";

const MainLayout: React.FC = () => {
  autoLogoff();

  return (
    <>
      <Header />
      <main>
        <Box p="md">
          <Container size={1440} py="lg" mx="auto">
            <Flex p="lg" mih={600} align="center">
              <Outlet />
            </Flex>
          </Container>
        </Box>
      </main>
      <Toaster richColors position="top-right" />
      <Footer />
    </>
  );
};

export {
  MainLayout
}
